import { environment } from '../../environments/environment'

export const DEFAULT_API_VERSION = 'v3'

// Builds a versioned API URL from a version-less path.
//   apiUrl('backoffice/transactions')       -> `${apiBaseUrl}/api/v3/backoffice/transactions`
//   apiUrl('backoffice/transactions', 'v2') -> `${apiBaseUrl}/api/v2/backoffice/transactions`
// Same-origin prod (apiBaseUrl === '') yields `/api/v3/...`.
export function apiUrl(path: string, version: string = DEFAULT_API_VERSION): string {
  const clean = path.replace(/^\/+/, '')
  return `${environment.apiBaseUrl}/api/${version}/${clean}`
}
